import { zonedTimeToUtc, utcToZonedTime } from '@adsk/date-fns-tz';
/**
 * Takes number or Date representation of date/time in current timezone, convert it to a Date, in the new timeZone (if provided)
 */
export default (_ref => {
  let {
    date,
    timeZone
  } = _ref;
  const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const utcTime = zonedTimeToUtc(date, currentTimeZone);
  const normalizedDate = utcToZonedTime(utcTime, timeZone || currentTimeZone);
  return normalizedDate;
});
//# sourceMappingURL=normalizeDate.js.map